<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="5">
                <el-input placeholder="SIM卡号" v-model="id"></el-input>
            </el-col>
            <el-col :span="5">
                <el-select v-model="batch">
                    <el-option value="" label="批号"></el-option>
                    <el-option v-for="x in selectList" :key="x" :value="x" :label="x"></el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="/sim/pay/add">
                    <el-button type="success">付款申请</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="ccid" label="SIM卡号">
            </el-table-column>
            <el-table-column prop="batch" label="批号">
            </el-table-column>
            <el-table-column prop="start" label="开始日期">
            </el-table-column>
            <el-table-column prop="end" label="结束日期">
            </el-table-column>
            <el-table-column prop="expireDateNum" label="到期天数">
            </el-table-column>
            <el-table-column prop="applyDate" label="申请日期">
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                data: [],
                id:'',
                batch:'',
                selectList:[],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        created() {
            this.$http.get('/manage/sim/batchList').then(data => {
                this.selectList = data['data']['data'];
            });
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.id.trim() != '') {
                    params.id = this.id;
                }
                if(this.batch.trim() != '') {
                    params.batch = this.batch;
                }
                this.$http.post('/manage/pay/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            }
        },
        components: { Pagination }
    }
</script>